import { render, staticRenderFns } from "./MappingH2HModal.vue?vue&type=template&id=63c6628e&scoped=true&"
import script from "./MappingH2HModal.vue?vue&type=script&lang=js&"
export * from "./MappingH2HModal.vue?vue&type=script&lang=js&"
import style0 from "./MappingH2HModal.vue?vue&type=style&index=0&id=63c6628e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6628e",
  null
  
)

export default component.exports